export function fmtUSD(n, decimals = 0) {
  const num = Number(n || 0);
  return num.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}

export function num(v) {
  const n = parseFloat(v);
  return isNaN(n) ? 0 : n;
}
